import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export const useMessage = () => {
    return {
    // 消息提示
        info(content: string) {
            ElMessage.info(content);
        },
        // 错误消息
        error(content: string) {
            ElMessage.error(content);
        },
        // 成功消息
        success(content: string) {
            ElMessage.success(content);
        },
        // 警告消息
        warning(content: string) {
            ElMessage.warning(content);
        },
        // 弹出提示
        alert(content: string, tip?: string, config: object = {}) {
            ElMessageBox.alert(content, tip ? tip : "提示", config);
        },
        // 错误提示
        alertError(content: string) {
            ElMessageBox.alert(content, "提示", { type: "error" });
        },
        // 成功提示
        alertSuccess(content: string) {
            ElMessageBox.alert(content, "提示", { type: "success" });
        },
        // 警告提示
        alertWarning(content: string) {
            ElMessageBox.alert(content, "提示", { type: "warning" });
        },
        // 通知提示
        notify(content: string) {
            ElNotification.info({
                title: "提示",
                message: content,
                offset: 100
            });
        },
        // 错误通知
        notifyError(content: string) {
            ElNotification.error({
                title: "错误",
                message: content,
                offset: 100
            });
        },
        // 成功通知
        notifySuccess(content: string) {
            ElNotification.success({
                title: "成功",
                message: content,
                offset: 100
            });
        },
        // 警告通知
        notifyWarning(content: string) {
            ElNotification.warning({
                title: "警告",
                message: content,
                offset: 100
            });
        },
        // 确认窗体
        confirm(content: string, tip?: string, config: object = {}) {
            return ElMessageBox.confirm(content, tip ? tip : "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                ...config
            });
        },
        // 删除窗体
        delConfirm(content?: string, tip?: string) {
            return ElMessageBox.confirm(
                content ? content : "是否删除所选中数据？",
                tip ? tip : "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            );
        },
        // 导出窗体
        exportConfirm(content?: string, tip?: string) {
            return ElMessageBox.confirm(
                content ? content : "是否确认导出数据项？",
                tip ? tip : "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            );
        },
        // 提交内容
        prompt(content: string, tip: string, config: object = {}) {
            return ElMessageBox.prompt(content, tip, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                ...config
            });
        },

        html(content: string) {
            return ElMessage({
                type: "success",
                dangerouslyUseHTMLString: true,
                message: content
            });
        },

        htmlAlert(content: string, tip?: string, config: object = {}) {
            return ElMessageBox.alert(content, tip ? tip : "提示", {
                dangerouslyUseHTMLString: true,
                ...config
            });
        }
    };
};
